// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr);
}

@media (min-width: 769px) {
	.skeleton-grid {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/common/loading/Skeleton.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,qCAAqC;AACtC;;AAEA;CACC;EACC,gDAAgD;CACjD;AACD","sourcesContent":[".skeleton-grid {\n\tdisplay: grid;\n\tgrid-template-columns: minmax(0, 1fr);\n}\n\n@media (min-width: 769px) {\n\t.skeleton-grid {\n\t\tgrid-template-columns: repeat(4, minmax(0, 1fr));\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
